module.exports = __webpack_public_path__ + "static/media/coinscope.b4be71d5.png";